import React from 'react'

import { theme } from '@factorialco/deprecated-design-system'
import { InAppCommsModal, InAppCommsSidebarCard, Maybe } from 'generated/resources/graphql'

interface MediaProps {
  content: Maybe<InAppCommsModal | InAppCommsSidebarCard> | undefined
}

const ExternalIframe = ({ url }: { url: string }) => {
  const videoId = url.split('v=')[1]?.split('&')[0]
  return (
    <iframe
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`}
      style={{
        borderRadius: theme.dimensions.s12,
        margin: '4px 4px 0 4px',
        aspectRatio: '16/9',
        backgroundColor: theme.colors.grey300,
      }}
    />
  )
}

const Media = ({ content }: MediaProps) => {
  if (content && 'externalUrl' in content && content.externalUrl) {
    return <ExternalIframe url={content.externalUrl} />
  }
  if (!content?.media?.[0]?.url) return null

  const mediaUrl = content.media[0].url
  const isVideo = /\.(mp4|webm|ogg|mov|avi)$/i.test(mediaUrl)
  const commonStyles = {
    borderRadius: theme.dimensions.s12,
    margin: '4px 4px 0 4px',
    aspectRatio: '16/9',
    backgroundColor: theme.colors.grey300,
  }

  return isVideo ? (
    <video
      src={mediaUrl}
      style={{
        ...commonStyles,
        pointerEvents: 'none',
      }}
      autoPlay
      muted
      loop
      playsInline
    />
  ) : (
    <img src={mediaUrl} style={commonStyles} />
  )
}

export default Media
